import { enumBoxShapes } from "../constants";
import { QRect } from "./QRect";
import { QXMLDoc } from "./QXMLDoc";
import { TruncateText } from "../utils/TruncateText";
import { XML_AddSingle } from "../utils/XML_AddSingle";
import { XML_Cmd1 } from "../utils/XML_Cmd1";
import { XML_AddBoundingRect } from "../utils/XML_AddBoundingRect.js";
import { XML_Param4 } from "../utils/XML_Param4.js";
import { XML_Cmd2 } from "../utils/XML_Cmd2.js";

export class QXMLDocShape extends QXMLDoc {
  constructor() {
    super();
  }

  ConvertY(yVal) {
    return yVal;
  }

  MakeText(theText, width, fontString) {
    var leftString = "";
    var rightString = "";
    var mainArray = theText[0];
    var rightArray = theText[1];
    var isJustified = false;
    for (var textIdx in mainArray) {
      var left = mainArray[textIdx];
      var right = rightArray[textIdx];
      left = TruncateText(left, fontString, width);
      if (right != null && right !== "") {
        rightString += right + "\n";
        isJustified = true;
      } else rightString += "\n";
      leftString += left + "\n";
    }
    return [leftString, rightString, isJustified];
  }

  AddClipRect(clipRect, layer) {
    // Does nothing - PPT does not support clipping
  }

  UseBoundingRect() {
    return true;
  }

  AddBoundingRect(boundingRect) {
    XML_AddBoundingRect(boundingRect, this);
  }

  DoFillRect(x, y, width, height, fillColor) {
    var r = new QRect();
    r.InitRect(x, y, x + width, y + height);
    this.CreatePath(r, enumBoxShapes.rectangle);
    XML_Cmd1("fi", fillColor, this);
  }

  CreatePath(bounds, boxShape) {
    var s = this.GetStream();
    this.OutputElementHead(s, "sh");
    var xmlshape;

    switch (boxShape) {
      case enumBoxShapes.rectangle:
        xmlshape = "Rect";
        break;
      case enumBoxShapes.snipCornerRectangle:
        xmlshape = "SRect";
        break;
      case enumBoxShapes.roundRectangle:
        xmlshape = "RRect";
        break;
      case enumBoxShapes.roundSnipCornerRectangle:
        xmlshape = "CRect";
        break;
    }

    XML_AddSingle(xmlshape, "id", this);
    XML_Param4(
      "b",
      bounds.fLeft,
      bounds.fTop,
      bounds.fRight - bounds.fLeft,
      bounds.fBottom - bounds.fTop,
      this
    );
    this.OutputElementTail(s, "sh");
  }

  DrawLargeArrow(x0, y0, x1, y1, x2, y2, x3, x4, fillColor) {
    var s = this.GetStream();
    this.OutputElementHead(s, "sh");

    var xLeft = Math.min(x0, x1, x2, x3, x4);
    var xRight = Math.max(x0, x1, x2, x3, x4);
    var yTop = Math.min(y0, y1, y2);
    var yBottom = Math.max(y0, y1, y2);

    var arrowType = "UpArr";
    if (y0 < y2) arrowType = "DownArr";
    XML_AddSingle(arrowType, "id", this);
    //XML_Param4("b", bounds.fLeft, bounds.fTop, bounds.fRight - bounds.fLeft, bounds.fBottom-bounds.fTop, this);
    this.OutputElementTail(s, "sh");

    XML_Cmd2("stk", "#000000", 1, this);
    XML_Cmd1("fi", fillColor, this);
  }

  DrawSmallArrow(x0, y0, x1, y1, x2, y2, style) {
    var stroke = "#FFFFFF";
    var fill = "#000000";
    if (style != null) {
      stroke = style.buttonStroke;
      fill = style.buttonFill;
    }
    var s = this.GetStream();
    this.OutputElementHead(s, "sh");

    var xLeft = Math.min(x0, x1, x2);
    var xRight = Math.max(x0, x1, x2);
    var yTop = Math.min(y0, y1, y2);
    var yBottom = Math.max(y0, y1, y2);

    var arrowType = "UpSArr";
    if (y0 < y2) arrowType = "DownSArr";
    XML_AddSingle(arrowType, "id", this);
    XML_Param4(
      "b",
      bounds.fLeft,
      bounds.fTop,
      bounds.fRight - bounds.fLeft,
      bounds.fBottom - bounds.fTop,
      this
    );
    this.OutputElementTail(s, "sh");
    XML_Cmd2("stk", stroke, 2, this);
    XML_Cmd1("fi", fill, this);
  }

  CreateTriPath(sx, sy, ex, ey, r, boxShape) {
    // This is the triangle in the upper right corner of the box
  }

  CreateTriPath2(sx, sy, ex, ey) {
    // Triangle in the upper right when you set the fill for a cell
  }

  SupportsClip() {
    return false;
  }

  PreJustifyText() {
    return true;
  }

  EndPage() {
    this.OutputElementTail(this.fStream, "grp");
    this.OutputElementTail(this.fStream, "pn");
  }
}
